"use strict";

exports.__esModule = true;
exports.isNumeric = isNumeric;
exports.isNaN = isNaN;
exports.isDate = isDate;
function isNumeric(val) {
  return /^\d+(\.\d+)?$/.test(val);
}

function isNaN(val) {
  if (Number.isNaN) {
    return Number.isNaN(val);
  } // eslint-disable-next-line no-self-compare


  return val !== val;
}

function isDate(val) {
  return Object.prototype.toString.call(val) === '[object Date]' && !(0, isNaN)(val.getTime());
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_mengzhua-ui@1.1.4@mengzhua-ui/components/utils/number.js
// module id = 7kSv
// module chunks = 68